(() => {
  const getCatalogCards = () => Array.from(document.querySelectorAll('#product-grid > [data-xe-category]'));

  const getFilterOrder = (card, filter) => {
    const orderTokens = card.dataset.xeOrders || '|';
    const marker = `|${filter}:`;
    const matchingOrder = orderTokens.split(marker)[1]?.split('|')[0];
    const parsedOrder = Number.parseInt(matchingOrder || '9999', 10);
    return Number.isNaN(parsedOrder) ? 9999 : parsedOrder;
  };

  const reorderCards = (cards, filter) => {
    const grid = cards[0]?.parentElement;
    if (!grid) return cards;

    const orderedCards = [...cards].sort((firstCard, secondCard) => {
      const firstOrder = getFilterOrder(firstCard, filter);
      const secondOrder = getFilterOrder(secondCard, filter);

      if (firstOrder !== secondOrder) return firstOrder - secondOrder;

      const firstDefaultOrder = Number.parseInt(firstCard.dataset.xeDefaultOrder || '9999', 10);
      const secondDefaultOrder = Number.parseInt(secondCard.dataset.xeDefaultOrder || '9999', 10);
      return firstDefaultOrder - secondDefaultOrder;
    });

    const currentCards = Array.from(grid.children).filter((card) => card.matches('[data-xe-category]'));
    const orderChanged = orderedCards.some((card, index) => currentCards[index] !== card);
    if (orderChanged) orderedCards.forEach((card) => grid.appendChild(card));

    return orderedCards;
  };

  const syncNativeCount = (cards = getCatalogCards()) => {
    const catalogCount = cards.length;
    document.querySelectorAll('#ProductCount, #ProductCountDesktop').forEach((count) => {
      count.textContent = `${catalogCount} ${catalogCount === 1 ? 'product' : 'products'}`;
    });
  };

  const initialiseCatalogCount = () => {
    const gridContainer = document.querySelector('#ProductGridContainer');
    syncNativeCount();
    if (!gridContainer || gridContainer.dataset.xeCountReady === 'true') return;

    gridContainer.dataset.xeCountReady = 'true';
    new MutationObserver(() => syncNativeCount()).observe(gridContainer, {
      childList: true,
      subtree: true,
    });
  };

  const initialise = (nav) => {
    if (nav.dataset.xeReady === 'true') return;
    nav.dataset.xeReady = 'true';

    const status = nav.querySelector('[data-xe-filter-count]');
    const initialButton = nav.querySelector('[data-xe-filter="all"]') || nav.querySelector('[data-xe-filter]');
    let activeFilter = initialButton?.dataset.xeFilter || 'all';

    const applyFilter = (filter) => {
      const cards = reorderCards(getCatalogCards(), filter);
      let visibleCount = 0;

      cards.forEach((card) => {
        const categoryTokens = card.dataset.xeCategory || '|unassigned|';
        const isVisible = filter === 'all' || categoryTokens.includes(`|${filter}|`);
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      nav.querySelectorAll('[data-xe-filter]').forEach((button) => {
        const isActive = button.dataset.xeFilter === filter;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      if (status) status.textContent = `${visibleCount} ${visibleCount === 1 ? 'product' : 'products'}`;
      syncNativeCount(cards);
      activeFilter = filter;
    };

    nav.addEventListener('click', (event) => {
      const button = event.target.closest('[data-xe-filter]');
      if (!button || !nav.contains(button)) return;
      applyFilter(button.dataset.xeFilter || 'all');
    });

    const gridContainer = document.querySelector('#ProductGridContainer');
    if (gridContainer) {
      new MutationObserver(() => applyFilter(activeFilter)).observe(gridContainer, {
        childList: true,
        subtree: true,
      });
    }

    applyFilter(activeFilter);
  };

  const initialiseAll = () => {
    initialiseCatalogCount();
    document.querySelectorAll('[data-xe-quick-filters]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);
})();
